"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var VideoProgressBar_1 = __importStar(require("./VideoProgressBar"));
var BORDER_RADIUS = (_a = {},
    _a[VideoProgressBar_1.borderTypesEnum.LEFT] = '0px 10px 10px 0px',
    _a[VideoProgressBar_1.borderTypesEnum.RIGHT] = '10px 0px 0px 10px',
    _a[VideoProgressBar_1.borderTypesEnum.ALL] = '50px',
    _a);
var VideoProgressedBar = styled_components_1.default.div.attrs(function (_a) {
    var progress = _a.progress;
    return ({
        style: {
            width: progress + "%",
        },
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 5px;\n  background: ", ";\n  border-radius: ", ";\n  transition: height 0.3s;\n  display: flex;\n  justify-content: flex-end;\n\n  ", ":hover & {\n    height: 8px;\n  }\n"], ["\n  height: 5px;\n  background: ", ";\n  border-radius: ", ";\n  transition: height 0.3s;\n  display: flex;\n  justify-content: flex-end;\n\n  ", ":hover & {\n    height: 8px;\n  }\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var radiusSide = _a.radiusSide;
    return BORDER_RADIUS[radiusSide];
}, VideoProgressBar_1.default);
exports.default = VideoProgressedBar;
var templateObject_1;
